const ORIGINAL_LOGO_URL = "https://static.prod-images.emergentagent.com/jobs/5b1ecf94-f189-4ab0-86c6-b36b6dcea7e5/images/ec211c63ecc4e706bdc93fa39cdcae42d4172e1e2e93982a0a8f8c8e6ff7475e.jpeg";

export function Logo({ compact = false }) {
  return (
    <div className="flex min-w-0 items-center gap-3 sm:gap-4" data-testid="site-logo">
      <img
        src={ORIGINAL_LOGO_URL}
        alt="V.T.C Tamil www.Vanniyantamil.com original logo"
        className="h-14 w-14 shrink-0 rounded-full object-cover object-center shadow-sm ring-2 ring-blue-900 sm:h-20 sm:w-20"
        data-testid="site-logo-original-image"
      />
      {!compact && (
        <div className="min-w-0 leading-tight" data-testid="site-logo-text">
          <p className="text-xl font-black text-blue-950 sm:text-3xl" data-testid="site-logo-primary-text">V.T.C Tamil</p>
          <p className="break-words text-sm font-black text-green-800 sm:text-xl" data-testid="site-logo-secondary-text">www.Vanniyantamil.com</p>
          <p className="mt-1 hidden text-xs font-bold uppercase tracking-[0.14em] text-slate-600 sm:block" data-testid="site-logo-tagline">ஒரே சமூக செய்தி தளம்</p>
        </div>
      )}
    </div>
  );
}